import type { LucideIconData } from '@lucide/angular';

/*
 * Lucide 1.x ships no brand icons. These are the stroke outlines earlier Lucide releases had for
 * them (ISC license), so they sit alongside the other icons in the footer.
 */

export const LucideLinkedinBrand: LucideIconData = {
  name: 'linkedin',
  node: [
    ['path', { d: 'M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z' }],
    ['rect', { width: '4', height: '12', x: '2', y: '9' }],
    ['circle', { cx: '4', cy: '4', r: '2' }],
  ],
};

export const LucideInstagramBrand: LucideIconData = {
  name: 'instagram',
  node: [
    ['rect', { width: '20', height: '20', x: '2', y: '2', rx: '5', ry: '5' }],
    ['path', { d: 'M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z' }],
    ['line', { x1: '17.5', x2: '17.51', y1: '6.5', y2: '6.5' }],
  ],
};
